import styles from "./navbar.module.css";
import { ReactComponent as Logo } from "../../assets/image/yptgl-logo.svg";

import redArrow from "../../assets/image/red-arrow.svg";
import { Link } from "react-router-dom";

const Navbar = ({ isRegistrationPage, isLiveUpdate }) => {
  return (
    <nav className={styles.navbar}>
      <Link to="/" className={styles.logo}>
        {/* <img src={logo} alt="logo" className={styles.logo} /> */}
        <Logo className={styles.logoimg} />
      </Link>

      <div
        className={`${styles.navBtnlayout} 
        ${isRegistrationPage ? styles.hideOnMobile : ""}
        ${isLiveUpdate ? styles.hide : ""}
        `}
      >
        <Link to="/register" className={styles.registerBtn}>
          <button>Register as a Donor</button>
        </Link>
        <Link to="/finalstats" className={styles.partnerBtn}>
          <button>
            Check Final Stats <img src={redArrow} alt="arrow" />
          </button>
        </Link>
      </div>
    </nav>
  );
};

export default Navbar;
